import 'spectrum';

// using TinyColor: https://github.com/bgrins/TinyColor
const formatter = tinycolor;

function rgbToHex(r, g, b, a = 1) {
  const color = formatter({ r, g, b, a });
  return color.toHexString();
}

function hexToRgb(hex) {
  const color = formatter(hex);
  return color.toRgb();
}

function hslToHex(h, s, l, a = 1) {
  const color = formatter({ h, s, l, a });
  return color.toHexString();
}

function hexToHsl(hex) {
  const color = formatter(hex);
  return color.toHsl();
}

function isValidHex(hex) {
  const color = formatter(hex);
  return color.isValid();
}

function darkenColor(hex, amount = 10) {
  const color = formatter(hex);
  return color.darken(amount).toString();
}

function toHex(format) {
  const color = formatter(format);
  return color.toHexString();
}

export default {
  toHex,
  rgbToHex,
  hexToRgb,
  hexToHsl,
  hslToHex,
  isValidHex,
  darkenColor,
};
